import { render } from "./WeaponIssueView.vue?vue&type=template&id=09fa52fc&scoped=true"
import script from "./WeaponIssueView.vue?vue&type=script&lang=js"
export * from "./WeaponIssueView.vue?vue&type=script&lang=js"

import "./WeaponIssueView.vue?vue&type=style&index=0&id=09fa52fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fa52fc"]])

export default __exports__